import React from "react";
import {Grid,} from "@material-ui/core";
import { useState } from "react";
import {useLocation, useNavigate} from 'react-router-dom';
import { Panel, BackButton, ButtonSubmit, SelectDropDown, Container } from "../../../../Components";
import { useStyles } from './Customer.styles';
import { useIntl } from "react-intl";
import CustomerSevicesApi from '../../../../Redux/Actions/CustomerAction';
import { useDispatch, useSelector } from 'react-redux';
import { TextField2,LanguageProps} from "../../../../Components/Field";
import { useApiValidationSnackbar } from "../../../../Components/Snackbar/SnackbarAlert";
import UserSevicesApi from "../../../../Redux/Actions/UserAction";
import { useSnackbar } from "notistack";
  interface CreateUserProps{
    firstName?:string,
    email?:string,
    lastName?:string,
    language?:any,
  }
  const CustomerUserInvite =()=> {
   const [userEdit, setUserEdit] =useState<CreateUserProps>({firstName: "", email: "",lastName:"",language:"Swidesh"});
   const navigate = useNavigate();
   const classes = useStyles();
   const { formatMessage } = useIntl();
   const dispatch:any = useDispatch();
   const {notifySuccess,ErrorMessage} = useApiValidationSnackbar();
   const { enqueueSnackbar } = useSnackbar();
   let customerIdParam = useLocation().state?.customerIdParam;

   const {currentUser,apiToken,userList,sendInvite} = useSelector((state:any) => ({
    currentUser:state?.UserReducer?.currentUser,
    apiToken:state?.UserReducer?.apiToken,
    userList:state?.UserReducer?.userList,
    sendInvite:state?.CustomerReducer?.sendInvite,
  }))
   React.useEffect(()=>{
  },[]);
    const submit=()=>{
      const Error:any="fill";
      if(!userEdit?.email || !userEdit?.firstName || !userEdit?.lastName || !userEdit?.language){
        ErrorMessage(sendInvite,Error);
      }else{
      const param = {
        email:userEdit?.email,
        firstName:userEdit?.firstName,
        lastName:userEdit?.lastName,
        language:LanguageProps[userEdit?.language],
        roleId: 0,    //inviting client admin
        sentBy: userList[0]?.id,
        customerId:customerIdParam
      }
      dispatch(CustomerSevicesApi.sendClientAdminInvitation(param,apiToken,enqueueSnackbar));
      if(sendInvite){
        setTimeout(() => {
          dispatch(UserSevicesApi.UserListData(currentUser?.customerId, apiToken,enqueueSnackbar));
      }, 1000);
        navigate("/administration/customers")
      }
    }
    }
    const handleOnchange = async (text: any, userEdit: any) => {
      setUserEdit(prevState => ({ ...prevState, [userEdit]: text?.target?.value }));
  };
    const cancelFrom = ()=>{
      setUserEdit({firstName: "", email: "",lastName:""})
    }
    return (<>
    <Container fullWidth>
        <Grid container justifyContent="flex-start">
          <BackButton link={`/administration/update-form/${customerIdParam}`}/>
        </Grid>
         <Panel titleKey="admin.users.invite.addUser">
        <Grid container spacing={2}>
          <Grid item xs={4}>
          <TextField2 onChange={(str: string) => setUserEdit({ ...userEdit, firstName: str })}
              placeholder={formatMessage({ id: "form.fillInFirstName", defaultMessage: "First name" })}
              value={userEdit.firstName} Textlabel="customer.create.firstName" />
          </Grid>
          <Grid item xs={4}>
          <TextField2 onChange={(str: string) => setUserEdit({ ...userEdit, lastName: str })}
              placeholder={formatMessage({ id: "form.fillInLastName", defaultMessage: "Last name" })}
              value={userEdit.lastName} Textlabel="customer.create.lastName" />
          </Grid>
          <Grid item xs={4}>
          <TextField2 onChange={(str: string) => setUserEdit({ ...userEdit, email: str })}
              placeholder={formatMessage({ id: "form.fillInEmail", defaultMessage: " Enter email" })}
              value={userEdit.email} Textlabel="customer.create.email" />
          </Grid>
        </Grid>
          <Grid item xs={5} className={classes.selectEmpty}>
            <SelectDropDown placeholder={formatMessage({ id: "customer.create.selectLanguage", defaultMessage: "Select Language" })}
            handleChange={(event) => setUserEdit({ ...userEdit, language: event.target.value })} fieldName={'lang'} OptionsValue={["Svenska", "English"]}
            ClassName={classes.selectDropdown} Textlabel="selectLanguage" selected={userEdit.language} />
          </Grid> 
        <Grid container justifyContent="space-between" className={classes.buttonStyle}>
          <ButtonSubmit text="component.mtable.cancelTooltip" onClick={cancelFrom}/>
          <ButtonSubmit text="admin.users.invite.add" onClick={submit}/>
        </Grid>
          </Panel>
          </Container>
      </>
    );
  }
  export default CustomerUserInvite;